import React, { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import axios from "axios";

// eslint-disable-next-line
import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
} from "@firebase/auth";

import NavBar from "./Navbar";

import "./App.css";
import { ConsoleView } from "react-device-detect";

function App(props) {
  // eslint-disable-line no-unused-vars

  const location = useLocation();

  const { only2studentid, studentid, classid, language, role, id } =
    useParams();

  const [id2, setId2] = useState();
  const [donotshow, setDonotshow] = useState();
  const [temparray, setTemparray] = useState();
  const [selectedclass, setSelectedclass] = useState();

  const [activeid, setActiveid = useState] = useState("123");
  const [activestudentlist, setActivestudentlist] = useState();

  const [activestudentlist2, setActivestudentlist2] = useState();

  const [activename, setActivename] = useState("Select Class");
  const [activeperiod, setActiveperiod] = useState("");

  const [currentclass, setCurrentclass] = useState();

  const [currentstudent, setCurrentstudent] = useState();

  const [potentialclass, setPoteentialclass] = useState();

  const [studentidd, setStudentidd] = useState();

  const [potentialclassid, setPotentiaalclassid] = useState();

  const [parentlanguagecode, setParentlanguagecode] = useState();

  const [courses2, setCourses2] = useState();

  const [students2, setStudents2] = useState();
  const [courses23, setCourses23] = useState();

  const [wherefrom, setWherefrom] = useState();

  const [localstorageindicator, setLocalstorageindicator] = useState();

  async function gogetstudents() {
    navigate("/Getstudents");
  }

  useEffect(() => {
    if (typeof location.state != "undefined" && location.state != null) {
      let anything2 = location.state.number;

      setWherefrom(anything2);
    }
  }, []);

  const auth = getAuth();

  async function signout() {
    auth.signOut();
    setId2();
  }

  useEffect(() => {
    if (wherefrom == 1) {
      getclassesA();
    }
  }, [wherefrom]);

  const getclassesA = async () => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      getclasses1();
    } else {
      getclasses22();
    }
  };

  async function getclasses1() {
    const absoluteUrl = "http://localhost:3002/login";
    const childWindow = window.open(absoluteUrl);
  }

  // setCourses2(data.courses);

  // if (data.courses.length > 0) {
  //   window.location.href = "http://localhost:3000/getclasses";
  // }

  //     // const absoluteUrl = "http://localhost:3002/login";
  //     // const childWindow = window.open(absoluteUrl);

  // const response = await fetch("http://localhost:3002/get-data");

  // // await fetchData();
  // if (data.courses.length > 0) {

  //     window.location.href = "http://localhost:3000/getclasses";
  // }

  // useEffect(() => {
  //   if (typeof courses2 != "undefined") {

  //     window.location.href = "http://localhost:3000/getclasses";
  //   }
  // }, [courses2]);

  const fetchData = async () => {
    console.log("fetchData was run");
    try {
      const response = await fetch("http://localhost:3002/get-data2");
      const data = await response.json();
      const accessToken = data;
      setCourses2(data.courses);
    } catch (error) {
      console.error("Error fetching access token:", error);
    }
  };

  const fetchData2 = async () => {
    console.log("fetchData2 was run");

    try {
      const response = await fetch("http://localhost:3002/get-data3");
      const data = await response.json();
      const accessToken = data;
      setStudents2(data.students);
    } catch (error) {
      console.error("Error fetching access token:", error);
    }
  };

  const getstudents1 = async () => {
    if (typeof potentialclassid != "undefined") {
      const classid = potentialclassid; // Replace with the actual class ID you want to send

      try {
        axios.defaults.headers.get["Content-Type"] = "application/json";

        const absoluteUrl = `http://localhost:3002/login2?classid=${classid}`;
        const childWindow = window.open(absoluteUrl);
      } catch (error) {
        console.log("Error fetching courses from API:", error);
      }
    }
  };

  const fetchstudentData22 = async () => {
    try {
      const response = await fetch(
        `http://localhost:3002/endpoint?classId=${potentialclassid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch students");
      }

      const students = await response.json();
      setActivestudentlist2(students);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const fetchstudentData = async () => {
    try {
      const response = await fetch("http://localhost:3002/getstudentdata");
      const data = await response.json();
      const accessToken = data;
      setCourses2(data.courses);
    } catch (error) {
      console.error("Error fetching access token:", error);
    }
  };

  useEffect(() => {
    if (typeof courses2 !== "undefined") {
      const convertZuluTimestampToDatetime = (timestamp) => {
        const date = new Date(timestamp);
        const date2 = date.getTime();
        return date2;
      };

      let sortedCourses = courses2.sort(
        (a, b) =>
          convertZuluTimestampToDatetime(b.creationTime) -
          convertZuluTimestampToDatetime(a.creationTime)
      );

      setCourses23(sortedCourses);
    }
  }, [courses2]);

  // filtere courses2
  const getclasses22 = async () => {
    // try {
    //   const response = await axios.get(
    //     "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/login"
    //   );
    // } catch (error) {}
  };

  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      setActiveid("123");
      setActivestudentlist([]);
      setActivename("Select Class");
      setActiveperiod("");
    }
  }, []);

  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      setActiveid(selectedclass.key);
      setActivestudentlist(selectedclass.students);
      setActivename(selectedclass.classname);
      setActiveperiod(selectedclass.period);
    }
  }, [selectedclass]);

  useEffect(() => {
    if (typeof potentialclass != "undefined") {
      setPotentiaalclassid(potentialclass.id);
    }
  }, [potentialclass]);

  useEffect(() => {
    if (
      typeof activeid != "undefined" &&
      activeid != "123" &&
      typeof activestudentlist2 != "undefined"
    ) {
      // filter sstudnets from this class

      let current = activestudentlist2.filter((person) =>
        person.classlist.includes(activeid)
      );

      setCurrentclass(current);
    }
  }, [activeid]);

  const navigate = useNavigate();

  const cardData = ["hello", "goodbye", "hii"];
  async function signout() {
    auth.signOut();
    setId2();

    navigate("/");
  }

  async function gogetstudents() {
    navigate("/Getstudents");
  }
  async function gogetclasses() {
    navigate("/Getclasses");
  }

  useEffect(() => {
    if (typeof location.state != "undefind" && location.state != null) {
      let anything = location.state.id;

      setId2(anything);
    }
  }, []);

  useEffect(() => {
    if (typeof id2 != "undefined") {
      getclasses();
      runthefunctiontogetstudents();
    }
  }, [id2]);

  useEffect(() => {
    if (potentialclassid != "undefined") {
      // fetchstudentData22();
      getstudents1();
    }
  }, [potentialclassid]);

  async function getclasses() {
    const f = query(
      collection(firebase, "classesbeingtaught"),
      where("teacherid", "==", id2)
    );

    const querySnapshot = await getDocs(f).then(function (snapshot) {
      const array = [
        { key: "123", classname: "Select Class", period: "", students: [] },
      ];

      snapshot.forEach((doc) => {
        let user = {
          key: doc.data().id,
          classname: doc.data().classname,
          period: doc.data().period,
          students: doc.data().students,
        };

        array.push(user);
      });
      setTemparray(array);
    });
  }

  useEffect(() => {
    if (
      typeof localstorageindicator != "undefined" &&
      localstorageindicator == "coursesloaded"
    ) {
      setTimeout(() => {
        localStorage.setItem("availablecourses", "not loaded");
      }, 2500);
    }

    if (
      typeof localstorageindicator != "undefined" &&
      localstorageindicator != "coursesloaded"
    ) {
      setTimeout(() => {
        localStorage.setItem("availablecourses", "coursesloaded");
      }, 2500);
    }
  }, [localstorageindicator]);

  async function runthefunctiontogetstudents(iddddd) {
    const q = query(
      collection(firebase, "users"),
      where("teacherlist", "array-contains", id2)
    );

    const snapshot1 = await getCountFromServer(q);
    const totalCount = snapshot1.data().count;
    const array = [];
    const querySnapshot = await getDocs(q)
      .then(async (snapshot) => {
        snapshot.forEach((doc) => {
          array.push(doc.data());
        });
      })
      .then(async (snapshot) => {
        console.log(array, "D");
        setActivestudentlist2(array);
      });
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        console.log("Tab is active", localstorageindicator);

        const username = localStorage.getItem("availablecourses");
        setLocalstorageindicator(username);
      } else {
        console.log("Tab is inactive");
        // Perform actions when the tab becomes inactive
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (
      typeof localstorageindicator != "undefined" &&
      localstorageindicator == "coursesloaded"
    ) {
      fetchData2();
    } else {
      setCourses2();
      setCourses23();
      setStudents2();
      setTimeout(() => {
        fetchData();
      }, 500);
    }
  }, [localstorageindicator]);

  const selectHandler299 = (value, i) => {
    if (value && potentialclassid != value.id) {
      alert("You have selected " + value.name);
      setPoteentialclass(value);
    } else {
      setPoteentialclass("");
    }
  };

  return (
    <div className="App22">
      <NavBar
        donotshow={donotshow}
        role={role}
        temparray={temparray}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activeid={activeid}
        parentlanguagecode={parentlanguagecode}
      />

      <div className="App">
        <header className="App-header">
          {/* 
        <Link to="/" style={{ textDecoration: 'none' }}>
      Return Select Class
      </Link> */}

          {typeof students2 == "undefined" &&
          typeof courses23 != "undefined" ? (
            <div className="centerme295">Available GC Classes</div>
          ) : typeof localstorageindicator != "undefined" &&
            localstorageindicator == "coursesloaded" ? (
            <div className="centerme295">Students Imported</div>
          ) : null}

          {typeof students2 == "undefined" &&
            typeof courses23 != "undefined" &&
            courses23.map((course, index) => (
              <div
                className={
                  course.id == potentialclassid ? "passstart2" : "passstart"
                }
                onClick={() => selectHandler299(course, index)}
              >
                <div key={course.id}>
                  {course.name}
                  <br></br>Created:{" "}
                  {new Date(course.creationTime).toLocaleDateString("en-US")}
                </div>
              </div>
            ))}

          {typeof students2 != "undefined" &&
            students2.map((course, index) => (
              <div
                style={{ display: "flex" }}
                key={course.userId}
                className={"passstart"}
              >
                <div style={{ flex: 0.5 }}>
                  <LazyLoadImage
                    src={`https:" + course.profile.photoUrl`}
                    alt={course.profile.name.fullName}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                    }}

                    // <img
                    //       src={"https:" + course.profile.photoUrl}
                    //       alt={course.profile.name.fullName}
                    //       style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <p>{course.profile.name.fullName}</p>
                </div>
              </div>
            ))}

          <div className="field229">
            <div className="innertext" onClick={() => signout()}>
              Sign Out
            </div>
          </div>
        </header>
      </div>
    </div>
  );
}

export default App;
